import { getFeatureMenuCustomName } from 'hb-react/frontoffice/utils/page';

export const itemTypeLabel = ({ itemType, pinned, pageCustomizables = [] }) => {
  switch (itemType) {
    case 'user-post':
    case 'posts_topic_post':
    case 'posts_feed_post':
      return __('Post');

    case 'venture':
    case 'ventures_venture':
      return getFeatureMenuCustomName(
        'ventures',
        __('Project'),
        pageCustomizables,
      );

    case 'trip':
      return __('Trip');

    case 'check-in':
    case 'current':
    case 'live':
      return __('Check-in');

    case 'user-event':
    case 'event':
    case 'network-event':
    case 'network_events_event':
      return pinned ? s__('LiveFeed|Pinned event') : __('Event');

    // TODO: remove this case when clean flagEvNewsRevamp
    case 'communications_post_communication':
      return pinned
        ? s__('LiveFeed|Pinned communication')
        : __('Communication');

    case 'communications_news':
      return pinned ? s__('LiveFeed|Pinned news') : __('News');

    case 'business_opportunities_request':
      return pinned ? s__('LiveFeed|Pinned opportunity') : __('Opportunity');

    case 'surveys_form':
      return __('Survey');

    case 'user':
      return __('New joiner');

    case 'tweet':
      return __('Tweet');

    default:
      return null;
  }
};
